import { render, staticRenderFns } from "./widget-template-gallery.vue?vue&type=template&id=cf2ed6c2&scoped=true&"
import script from "./widget-template-gallery.vue?vue&type=script&lang=js&"
export * from "./widget-template-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2ed6c2",
  null
  
)

export default component.exports